export enum CallDisconnectReason {
  /**
   * The call disconnected due to too much time passed since the last
   * heartbeat from the user.
   */
  HeartbeatTimedOut = 'heartbeatTimedOut',

  /**
   * The contact hung up the call.
   */
  ContactHangUp = 'contactHangUp',
  
  /**
   * The call was hung up via a call action.
   */
  CallAction = 'callAction',

  /**
   * The call was hung up due to reaching voice mail.
   */
  Voicemail = 'voicemail',

  /**
   * Predictive mode ended with no remaining users.
   */
  NoPredictiveModeUsers = 'noPredictiveModeUsers',

  /**
   * The user hung up the call by clicking the hang-up button.
   */
  UserHangUpNormal = 'userHangUpNormal',

  /**
   * User hung up via co-hearing.
   */
  UserHangUpCohearing = 'userHangUpCohearing',

  /**
   * The user hung up the call by answering an inbound call.
   */
  UserAnswerInboundCall = 'userAnswerInboundCall',

  /**
   * The user hung up the call by leaving the lead list's predictive queue.
   */
  UserLeavePredictiveQueue = 'userLeavePredictiveQueue',

  /**
   * The user ended cohearing mode. For parked calls only.
   */
  UserEndCohearing = 'userEndCohearing',

  /**
   * The user hung up the call automatically by distributing an offer.
   */
  UserDistributedOffer = 'userDistributedOffer',

  /**
   * Reserved for 1 other reason why the user hung up the call.
   */
  UserOther = 'userOther',

  /**
   * Other reason, see disconnectCode.
   */
  Other = 'other',
}